import { render, staticRenderFns } from "./Kidzwonder3D.vue?vue&type=template&id=c9d9f074&scoped=true"
import script from "./Kidzwonder3D.vue?vue&type=script&lang=js"
export * from "./Kidzwonder3D.vue?vue&type=script&lang=js"
import style0 from "./Kidzwonder3D.vue?vue&type=style&index=0&id=c9d9f074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d9f074",
  null
  
)

export default component.exports